import validate from "/usr/src/app/content/n3-treatments-d7532aba-d139-4ddf-a199-5da42b679886/b2c-build/node_modules/nuxt/dist/pages/runtime/validate.js";
import manifest_45route_45rule from "/usr/src/app/content/n3-treatments-d7532aba-d139-4ddf-a199-5da42b679886/b2c-build/node_modules/nuxt/dist/app/middleware/manifest-route-rule.js";
export const globalMiddleware = [
  validate,
  manifest_45route_45rule
]
export const namedMiddleware = {}